import { ChessTermType, TermAction, } from "@chesshotel/types";
import { Chess } from "@chesshotel/chess";
import { exchangeEvaluation, getFen, uci2move, pieceValues, getThreats, } from "./util.js";
import { isValidFenMove } from "./tactics/util.js";
export function detectNegativeMaterialWin(position, lastPosition) {
    const chessTerms = [];
    const allow = detectMaterialWinActions(position, lastPosition, TermAction.ALLOW);
    if (allow &&
        position.chessTerm &&
        position.chessTerm.term != ChessTermType.MATERIAL_WIN &&
        position.chessTerm.moveTree) {
        if (position.chessTerm.moveTree.find((moves) => moves.find((move) => move.from == allow.move.from && move.to == allow.move.to))) {
            return null;
        }
    }
    if (allow) {
        chessTerms.push(allow);
    }
    const miss = detectMaterialWinActions(position, lastPosition, TermAction.MISS);
    if (miss) {
        chessTerms.push(miss);
    }
    const betterWay = detectMaterialWinActions(position, lastPosition, TermAction.BETTER_WAY);
    if (betterWay) {
        if (position.chessTerm?.term == ChessTermType.RETAKE ||
            position.chessTerm?.term == ChessTermType.TAKES_BACK ||
            position.chessTerm?.term == ChessTermType.TRADE) {
            betterWay.term = position.chessTerm.term;
            position.chessTerm = null;
            position.chessTerms = [];
        }
        chessTerms.push(betterWay);
    }
    if (chessTerms.length > 0)
        return chessTerms;
    return null;
}
export function detectPositiveMaterialWin(position, lastPosition) {
    if (position.chessTerm) {
        return null;
    }
    const performEventual = detectMaterialWinActions(position, lastPosition, TermAction.PERFORM);
    if (performEventual)
        return performEventual;
}
function detectMaterialWinActions(position, lastPosition, termAction) {
    if (termAction == TermAction.PERFORM) {
        const materialWin = detectMaterialWin(lastPosition.fen, position.move);
        if (materialWin) {
            return { ...materialWin, termAction };
        }
    }
    if (termAction == TermAction.ALLOW) {
        const opponentMove = position.pvMoves[0];
        const userAllow = detectMaterialWin(position.fen, opponentMove);
        if (userAllow) {
            const bestFen = getFen(lastPosition.fen, lastPosition.pvMoves[0]);
            const isValid = isValidFenMove(bestFen, opponentMove);
            if (!isValid) {
                return { ...userAllow, termAction: TermAction.ALLOW };
            }
            const bestAllow = detectMaterialWin(bestFen, opponentMove);
            if (!bestAllow) {
                return { ...userAllow, termAction: TermAction.ALLOW };
            }
        }
    }
    if (termAction == TermAction.MISS) {
        const user = detectMaterialWin(lastPosition.fen, position.move);
        const best = detectMaterialWin(lastPosition.fen, lastPosition.bestMove);
        if (best && !user) {
            return { ...best, termAction };
        }
    }
    if (termAction == TermAction.BETTER_WAY) {
        const user = detectMaterialWin(lastPosition.fen, position.move, position.chessTerm?.term);
        const best = detectMaterialWin(lastPosition.fen, lastPosition.bestMove, position.chessTerm?.term);
        if (best && user) {
            return { ...best, termAction };
        }
    }
}
export function counterAttackGain(fen, color, notSquare) {
    const threats = getThreats(fen, color);
    if (threats?.length > 0) {
        const bestThreat = threats
            .filter((threat) => threat.to.square != notSquare)
            .sort((a, b) => b.gain - a.gain)[0];
        if (bestThreat?.gain > 0) {
            return bestThreat.gain;
        }
    }
    return 0;
}
export function detectMaterialWin(fen, move, precalculatedTerm) {
    const chess = new Chess(fen);
    const color = chess.turn();
    const moveResult = chess.move(uci2move(move));
    if (moveResult?.captured) {
        const exchange = exchangeEvaluation(fen, moveResult.to, {
            from: moveResult.from,
            backtrackBadMoves: true,
            backtrackKeepFirstMove: false,
            filteredByLoss: true,
        });
        if (exchange && exchange.gain > 0) {
            let term;
            if (exchange.moveSequence.length == 1) {
                const capturedPieceValue = pieceValues[moveResult.captured];
                const pieceValue = pieceValues[moveResult.piece];
                if (capturedPieceValue > pieceValue) {
                    term = ChessTermType.DIRECT_MATERIAL_WIN;
                }
                else {
                    term = ChessTermType.HANGING;
                }
            }
            else {
                term = ChessTermType.MATERIAL_WIN;
            }
            if (precalculatedTerm != ChessTermType.TRADE &&
                precalculatedTerm != ChessTermType.BAD_TRADE &&
                precalculatedTerm != ChessTermType.RETAKE &&
                precalculatedTerm != ChessTermType.TAKES_BACK) {
                const counterGain = counterAttackGain(chess.fen(), color, moveResult.to);
                if (counterGain >= exchange.gain) {
                    return null;
                }
            }
            const translationKeys = { piece: exchange.pieceWin };
            const arrows = [{ from: moveResult.from, to: moveResult.to }];
            return {
                term,
                evalResult: exchange,
                maxGain: exchange.gain,
                move: moveResult,
                translationKeys,
                arrows,
            };
        }
    }
}
//# sourceMappingURL=materialWin.js.map